import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from 'antd';
import cs from 'classnames';

import { Job } from 'types/jobs';

import { JobStatus } from 'constants/enums';
import { EDIT, JOBS } from 'constants/path';

import { ReactComponent as EditIcon } from 'assets/icons/edit-square.svg';

import styles from './EditJobButton.module.scss';

interface EditJobButtonProps {
  job: Job;
  className?: string;
}

const EditJobButton: FC<EditJobButtonProps> = ({ job, className }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleEditClick = () => {
    navigate(`${JOBS}/${job.id}${EDIT}`);
  };

  const isDisabled =
    job.status === JobStatus.Completed ||
    job.status === JobStatus.InReview ||
    job.activeApplications > 0;

  return (
    <Button
      className={cs(styles.editJobsButton, className)}
      type="primary"
      icon={<EditIcon />}
      onClick={handleEditClick}
      disabled={isDisabled}
    >
      {t('cardActions.label.edit')}
    </Button>
  );
};

export default EditJobButton;
